import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notif-warning',
  templateUrl: './notif-warning.component.html',
  styleUrls: ['./notif-warning.component.css']
})
export class NotifWarningComponent implements OnInit {
  @Input() msg : string;
  @Input() closable : string;
  constructor() { }

  ngOnInit() {
  }

}
